/* eslint-disable */
require('script-loader!file-saver');
require('./Blob.js');
require('script-loader!xlsx/dist/xlsx.core.min');
import XLSX from 'xlsx'
export function importExcel2Json (file, header) {
  return new Promise(function(resolve, reject) {
    const reader = new FileReader();
    reader.onload = function(e) {
      const data = e.target.result;
      this.wb = XLSX.read(data, {
        type: "binary"
      });
      const result = [];
      // this.wb.SheetNames.forEach(sheetName => {
        let sheetName = this.wb.SheetNames[0]
        result.push({
          sheetName: sheetName,
          sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName],{header: header})
        })
      // })
      resolve(result);
    }
    // reader.readAsBinaryString(file.raw);         // Element 组件专用
    reader.readAsBinaryString(file.file);           // Ant     组件专用
  })
}